var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',{staticClass:"article-title"},[_vm._v(_vm._s(_vm.articleTitle))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.articleHtml)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }